import { ChangeDetectionStrategy, Component, input, output, ViewEncapsulation } from '@angular/core';
import { WhiteLabelFaqItem } from '../../typings';

@Component({
  selector: 'wil-landing-faq',
  standalone: true,
  templateUrl: './landing-faq.component.html',
  styleUrl: './landing-faq.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class LandingFaqComponent {
  public readonly items = input.required<readonly WhiteLabelFaqItem[]>();
  public readonly expandedItems = input.required<ReadonlySet<number>>();
  public readonly itemToggled = output<number>();
}
